import { render, staticRenderFns } from "./CButton.vue?vue&type=template&id=69621422&"
import script from "./CButton.vue?vue&type=script&lang=js&"
export * from "./CButton.vue?vue&type=script&lang=js&"
import style0 from "./CButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports